import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import Securebadge from "../../Assets/intasend-assets/Trust Badge Light.png";
import SocialLinks from "../../Elements/SocialLinks";
import servicesData from "../Data/ServiceData";
import { Link } from "react-router-dom"; // For dynamic routes

const FooterWrapper = styled.footer`
  color: #444444;
  font-size: 14px;
  background: #f9f9f9;
  font-family: "Roboto", sans-serif;
`;

const FooterTop = styled.div`
  padding: 50px 0;
  background: rgb(216, 230, 250);
  color: rgb(22, 137, 252);
`;

const FooterContact = styled.div`
  margin-bottom: 10px;

  h3 {
    font-size: 1.5rem;
    font-weight: 800;
    color: #333333;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  p {
    font-size: 14px;
    line-height: 10px;
    margin: 0;
    decoration: none;
  }
`;

const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
  }
`;


const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  i {
    font-size: 28px;
    color: #db3434;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #444;
  }

  p a {
    color: gray;
    text-decoration: none;
    transition: color 0.3s;
  }

  p a:hover {
    color: #db3434;
  }

  @media (max-width: 768px) {
    i {
      font-size: 24px;
    }
    p {
      font-size: 12px;
    }
  }
`;

const FooterLinks = styled.div`
  h4 {
    font-size: 1rem;
    font-weight: 800;
    color: #333333;
    margin-bottom: 0.2rem;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  ul li a {
    display: inline-block;
    max-width: 150px; /* Adjust as needed */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; /* Prevent wrapping */
    color: rgb(7, 122, 238);
    text-decoration: none;
    transition: all 0.3s ease;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  ul li {
    padding: 5px 0;
    transition: all 0.3s;
  }

  ul li a {
    color: rgb(22, 137, 252);
    text-decoration: none;
    transition: all 0.3s ease;
  }

  ul li a:hover {
    color: #f07b26;
    transform: translateX(5px);
  }
`;

// const FooterNewsletter = styled.div`
//   h4 {
//     font-size: 18px;
//     font-weight: bold;
//     color:rgb(22, 25, 210);
//     margin-bottom: 20px;
//     text-transform: uppercase;
//   }

//   form {
//     display: flex;
//     background: #ffffff;
//     border-radius: 16px;
//     // overflow: hidden;

//     input[type="email"] {
//       border: none;
//        border-radius: 25px;
//       padding: 10px;
//       flex: 1;
//       font-size: 14px;
//       color: #444444;
//     }

//     input[type="submit"] {
//       background:rgb(17, 60, 249);
//       color: #ffffff;
//        border-radius: 25px;
//       border: none;
//       padding: 0 10px;
//       cursor: pointer;
//       transition: all 0.3s;
//     }

//     input[type="submit"]:hover {
//       background:rgb(98, 6, 6);
//     }
//   }
// `;

const Newsletter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;

  p {
    font-size: 1rem;

    @media (max-width: 480px) {
      font-size: 0.9rem;
    }
  }

  div {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    gap: 10px;

    @media (max-width: 480px) {
      flex-direction: column;
      align-items: stretch;
      gap: 5px;
    }
  }

  input {
    padding: 10px;
    width: 250px;
    border: none;
    border-radius: 5px;

    @media (max-width: 480px) {
      width: 100%;
    }
  }

  button {
    padding: 10px 20px;
    border: none;
    background-color: #ff5757;
    color: white;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-items: left;

    &:hover {
      background-color: #e55a00;
      transform: scale(1.05);
    }

    @media (max-width: 480px) {
      width: 100%;
    }
  }
`;
const FooterBottom = styled.div`
  background: #0b3467;
  color: #ffffff;
  padding: 5px 10px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;


const TrustBadgeWrapper = styled.div`
  position: relative;
  display: inline-block;
  
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 255, 0.4); /* Blue overlay with 40% opacity */
    border-radius: 5px;
  }
`;

const TrustBadge = styled.img`
  height: 70px;
  object-fit: cover;
  display: block;
`;

function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async () => {
    if (!/\S+@\S+\.\S+/.test(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    try {
      const response = await axios.post(
        "https://admin.pristineacademicconsultancy.com/subscribe.php",
        { email },
        { headers: { "Content-Type": "application/json" } }
      );
      setMessage(response.data.message);
      setEmail(""); // Clear input on success
    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
          setMessage("Email is already subscribed.");
        } else {
          setMessage(error.response.data.message || "Server error occurred.");
        }
      } else if (error.request) {
        setMessage("No response from server. Please check your connection.");
      } else {
        setMessage("Error: " + error.message);
      }
    }
  };

  return (
    <FooterWrapper>
      <FooterTop>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <FooterContact>
                <h3>Pristine Academic Consultancy</h3>
                <InfoContainer>
            <InfoItem>
              <i className="ri-map-pin-line"></i>
              <p>Nairobi, Kenya</p>
            </InfoItem>
            <InfoItem>
              <i className="ri-mail-send-line"></i>
              <p>
                <a href="mailto:pristineeduconsult@gmail.com">
                  pristineacademicconsultancy@gmail.com
                </a>
              </p>
            </InfoItem>
          </InfoContainer>
              </FooterContact>
            </div>
            <div className="col-lg-3 col-md-6">
              <FooterLinks>
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li>
                    <Link to="/privacy">Privacy Policy</Link>
                  </li>
                </ul>
              </FooterLinks>
            </div>
            <div className="col-lg-3 col-md-6">
              <FooterLinks>
                <h4>Our Services</h4>
                <ul>
                  {servicesData.map((service) => (
                    <li key={service.id}>
                      <Link
                        to={`/services/${service.id}`}
                        title={service.title}
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </FooterLinks>
            </div>
            <div className="col-lg-3 col-md-6">
              <Newsletter>
                <p>Please subscribe to our newsletter</p>
                <div>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button onClick={handleSubscribe}>Subscribe</button>
                </div>
                {message && <p>{message}</p>}
              </Newsletter>
            </div>
          </div>
        </div>
      </FooterTop>
      <FooterBottom>
       
       <SocialLinks/>
        <p>
          &copy; {new Date().getFullYear()} Pristine Academic Consultancy . All Rights
          Reserved.
        </p>
        <TrustBadgeWrapper>
  <TrustBadge src={Securebadge} alt="Trust Badge" />
</TrustBadgeWrapper>

      </FooterBottom>
    </FooterWrapper>
  );
}

export default Footer;
